export default class CNPJValidador {

  static mullArr = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]

  static joiValidate(cnpj, helper) {
    if (CNPJValidador.validate(cnpj))
      return cnpj
    return helper.message('Invalid CNPJ.')
  }

  static validate(cnpj) {
    if (!cnpj || typeof cnpj !== 'string')
      return false

    if (cnpj.length !== 14 || !cnpj.match(/^[0-9]*$/))
      return false

    const digits = cnpj.split('').map(Number)

    if (digits.every(d => digits[0] === d))
      return false

    if (CNPJValidador.getDigit(digits) !== digits[digits.length - 2])
      return false

    if (CNPJValidador.getDigit(digits, 0) !== digits[digits.length - 1])
      return false

    return true
  }

  static getDigit(digits, offset = 1) {
    let sum = 0

    for (let i = offset; i < CNPJValidador.mullArr.length; i++)
      sum += digits[i - offset] * CNPJValidador.mullArr[i]

    let div = sum % 11

    return div < 2 ? 0 : 11 - div
  }
}
